import React from 'react'
import { PageIndexRecord } from '@/search/types'
import { BaseSearchHit } from './BaseSearchHit'
import { HighlightHit } from './HighlightHit'
import { SearchHitTextBlock } from './SearchHitTextBlock'
import { BaseSearchHitProps } from './types'

export const PageSearchHit: React.JSXElementConstructor<BaseSearchHitProps<PageIndexRecord>> = ({ hit }) => {
  return (
    <BaseSearchHit hit={hit}>
      <div className="w-full py-1">
        <SearchHitTextBlock
          label={<HighlightHit hit={hit} attribute="name" />}
          caption={<HighlightHit hit={hit} attribute="pageType" />}
        />
      </div>
    </BaseSearchHit>
  )
}
